import { getModel } from "core-web/state";
import { post } from "core-web/libs/GrebbCommerceAPI/util";

export default async (productId, categoryId) => {
    const response = await post(`/frontend/product/id/${productId}/view`, {
        application_id: getModel("application").applicationId,
        category_id: categoryId,
    });

    return await response.body();
};
